import { cva } from '@/styled-system/css';

export const expandIconRecipe = cva({
  base: {
    display: 'inline-flex',
    transformOrigin: 'center',
    transition: {
      _motionReduce: 'none',
      _motionSafe: 'transform 250ms cubic-bezier(0.76, 0, 0.24, 1)',
    },
  },
  variants: {
    open: {
      true: {
        transform: 'rotate(180deg)',
      },
      false: {
        transform: 'rotate(0deg)',
      },
    },
  },
});
